const SOCIAL_HOST_PATTERNS = [
  "tiktok.com",
  "instagram.com",
  "facebook.com",
  "fb.com",
  "linkedin.com",
  "youtube.com",
  "youtu.be",
  "twitter.com",
  "x.com",
];

function getHost(url: string | undefined): string {
  if (!url) return "";
  try {
    return new URL(url, "https://webmotors.com.br").hostname.toLowerCase();
  } catch {
    return "";
  }
}

function isSocialUrl(url: string | undefined): boolean {
  const host = getHost(url);
  return SOCIAL_HOST_PATTERNS.some(
    (pattern) => host === pattern || host.endsWith("." + pattern)
  );
}

function isWebmotorsUrl(url: string | undefined): boolean {
  const host = getHost(url);
  return host.includes("webmotors");
}

export function getLinkTarget(
  url: string | undefined,
  shouldOpenInSameWindow: boolean
): { target: "_self" | "_blank"; rel?: string } {
  if (!url) {
    return { target: "_blank", rel: "noopener noreferrer" };
  }
  if (isSocialUrl(url)) {
    return { target: "_blank", rel: "noopener noreferrer" };
  }
  if (shouldOpenInSameWindow && isWebmotorsUrl(url)) {
    return { target: "_self" };
  }
  return { target: "_blank", rel: "noopener noreferrer" };
}
